import React from 'react'
import { Controller } from 'react-hook-form'
import CustomPhoneInput from './TelInput'

// required props: 
// {
//     name, // string
//     control, // control-object-react-hook-form
//     label, // string
//     error, // boolean
//     helperText, // string
//     showLabel, // boolean
// }

const TelInputController = ({
    name, // Input name, id(if not provided)
    control, // react-hook-form control
    label, // Input Label, aria-label
    error, // Is there Error? (true/ false)
    helperText, // Helper Text
    showLabel, // Show Label or not
    ...props // All other props
}) => {
  return (
    // Controller from react-hook-form
    <Controller
        name={name}
        control={control}
        defaultValue={props.defaultValue || ""}
        render={({ field: { onChange, onBlur, value }, fieldState: { error } }) => (
          // Our custom InputField(mui)
            <CustomPhoneInput
                value={value}
                onChange={onChange}
                onBlur={onBlur}
                name={name}
                error={error} // Pass error state
                label={label} // Label
                helperText={helperText} // Pass helper text
                {...props} // Other props
            />
        )}
    />
  )
}

export default React.memo(TelInputController)